import React from 'react';
import PropTypes from 'prop-types';
import { DateTime } from 'luxon';
import { useConnect } from '@lore/query-connect';
import useMissingFields from '@/pages/project-manage/useMissingFields';
import { getTimestampDiff } from '@/utils/dateTimeUtils';
import ActiveBanner from './ActiveBanner';
import DraftBanner from './DraftBanner';
import HiddenBanner from './HiddenBanner';
import CompletedBanner from './CompletedBanner';
import CancelledBanner from './CancelledBanner';
import ExpiredBanner from './ExpiredBanner';

Banner.propTypes = {
  project: PropTypes.shape({
    id: PropTypes.any.isRequired,
    data: PropTypes.shape({
      creatorId: PropTypes.any,
      completed: PropTypes.bool,
      cancelled: PropTypes.bool,
      published: PropTypes.bool,
      endDate: PropTypes.string
    }).isRequired
  }).isRequired
};

export default function Banner(props) {
  const { project } = props

  const { missingFields } = useMissingFields(project);

  const creator = useConnect('user.byId', {
    id: project.data.creatorId
  });

  if (project.data.completed) {
    return (
      <CompletedBanner
        project={project}
        creator={creator}
      />
    );
  }

  if (project.data.cancelled) {
    return (
      <CancelledBanner
        project={project}
        creator={creator}
      />
    );
  }

  if (missingFields.data.length > 0) {
    return (
      <DraftBanner
        project={project}
        creator={creator}
      />
    );
  }

  if (!project.data.published) {
    return (
      <HiddenBanner
        project={project}
        creator={creator}
      />
    );
  }

  const diff = getTimestampDiff(DateTime.now().toISO(), project.data.endDate);

  if (diff > 0) {
    return (
      <ExpiredBanner
        project={project}
        creator={creator}
      />
    );
  }

  return (
    <ActiveBanner
      project={project}
      creator={creator}
    />
  );
};
